export enum InstallationTypeEnum {
  Interlocking = 0, // emboitée
  Shutter = 1, // persiennée
  Openwork = 2, // ajourée
  SteelFence = 3, // clôture acier
  VerticalInterlocking = 4 // emboitée verticale
}
